import { render, staticRenderFns } from "./RubricVersionStatusRenderer.vue?vue&type=template&id=ca9c4cc2&"
import script from "./RubricVersionStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./RubricVersionStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports